import * as React from "react";
import { Button, Dropdown } from "antd";
import { ChevronDown } from "react-feather";
import { ViewModal } from "../../../../components/modals/viewModal";
import { useNodePoolScripts } from "./useNodePoolScripts";

interface Props {
  clusterName: string;
  nodePoolName: string;
  poolType: string;
  supportsCloudinit?: boolean;
}

export const NodePoolActionsDropdown: React.FC<Props> = ({
  clusterName,
  nodePoolName,
  poolType,
  supportsCloudinit = false,
}) => {
  const {
    joinScript,
    cloudinitScript,
    handleJoinScript,
    handleCloudinitScript,
    clearJoinScript,
    clearCloudinitScript,
  } = useNodePoolScripts({ clusterName, nodePoolName });

  const menuItems = [{ key: "join", label: "Download Join Script" }];
  if (supportsCloudinit) {
    menuItems.push({ key: "cloudinit", label: "Download Cloud Init Script" });
  }

  return (
    <>
      <Dropdown
        trigger={["click"]}
        menu={{
          onClick: async function ({ key }: { key: string }) {
            switch (key) {
              case "join":
                handleJoinScript();
                break;
              case "cloudinit":
                handleCloudinitScript();
                break;
              default:
                break;
            }
          },
          items: menuItems,
        }}
      >
        <Button type="primary" size="small" icon={<ChevronDown className="feather-icon" />} iconPosition="end">
          Node Pool Actions
        </Button>
      </Dropdown>
      {!!joinScript ? (
        <ViewModal
          title={`${poolType} Join Script`}
          rawContent={joinScript}
          rawLanguage="bash"
          filename={`${clusterName}-${nodePoolName}-joinScript`}
          onClose={clearJoinScript}
          visible={!!joinScript}
        />
      ) : null}
      {!!cloudinitScript ? (
        <ViewModal
          title={`${poolType} Cloud Init Script`}
          rawContent={cloudinitScript}
          rawLanguage="yaml"
          filename={`${clusterName}-${nodePoolName}-cloudInit`}
          onClose={clearCloudinitScript}
          visible={!!cloudinitScript}
        />
      ) : null}
    </>
  );
};
